module.exports = __webpack_public_path__ + "src/assets/img/generating/b1e44a95ad3c6a776afbe3427cd1793b.png";